import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EndorsementState } from './endorsement.state';

export const selectEndorsement = createFeatureSelector<EndorsementState>('endorsement');

export const selectEndorsementState = createSelector(
  selectEndorsement,
  (state: EndorsementState) => state.endorsements
);
